import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,[_c(VCardText,[_c('distribution-view',{attrs:{"data":_vm.referrerData,"color-map":{
        Search: '#22AB32',
        Social: '#0074D9',
        Direct: '#F0C419',
        Other: '#F15A5A',
        Paid_Search: '#955BA5',
        None: '#C9ADA1',
        Self: '#4D6A6D',
      },"order-by":"key","translate":"monitoring.data"}})],1),_c(VCard,{staticClass:"card-bar elevation-0",attrs:{"color":"infoBar","dark":""}},[_c('div',{staticClass:"card-progress-container"},[_c(VProgressLinear,{directives:[{name:"show",rawName:"v-show",value:(!_vm.$store.state.monitoring.realtime.referrerTypes.loaded),expression:"!$store.state.monitoring.realtime.referrerTypes.loaded"}],attrs:{"height":7,"color":"primary","indeterminate":""}})],1),_c(VCardText,{staticClass:"white--text"},[_c(VRow,[_c(VCol,{attrs:{"cols":"12"}},[_c('span',[_vm._v("Top Referrer:")]),_c('span',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.$store.state.monitoring.facts.referrer.data.length ? _vm.$store.state.monitoring.facts.referrer.data[0].key : '-'))])])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }